// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

//scroll anchor links under the header
$(document).ready( function() {
    if(window.location.hash){
        var $target = $(window.location.hash)
        var headerHeight = $('header').height()
        if($target.length > 0) {
            $('html, body').animate({scrollTop: $target.offset().top - headerHeight } , 400);
        }
    }
    $(document).on('click', 'a[href*="#"], a[href*="ostoskori"]', function(e) {
        e.preventDefault();
        var href = $(this).attr("href");
        let current_url = window.location.href.split('#')[0];
        if( ( href.startsWith("#") || href.startsWith(current_url + "#") ) && href !== '#' ) {
            var target = href.split("#")[1]
            if( $('#' + target).length > 0 ) {
                var headerHeight = $('header').height()
                $('html, body').animate({scrollTop: $('#' + target).offset().top - headerHeight } , 400);
            }
        }  else if (href.includes("ostoskori")) {
            $("#side-cart").addClass("open");
            $("#cart-overlay").addClass("active");
        } else {
            window.location.href = href;
        }
    })
})

//contact form sent message
$(document).on('wpcf7mailsent', function(event) {
    var $form = $(event.target);

    var $thankYouInput = $form.find('input[name="thank_you_url"]');
    if ($thankYouInput.length && $thankYouInput.val()) {
        // Jos thank_you_url kenttä, ohjaa kyseiselle kiitos-sivulle
        window.location.href = $thankYouInput.val();
    } else {
        // Jos kiitos-sivun URL:ia ei ole asetettu, näytetään lomakkeen lähetyksen jälkeen ponnahdusikkuna
        setTimeout(function() {
            var $responseOutput = $form.find('.wpcf7-response-output');
            
            $responseOutput.wrapInner('<div class="wrapper"></div>');
            var $wrapper = $responseOutput.find('.wrapper');
            
            $wrapper.prepend(
                '<div class="background"></div>' +
                '<div class="close-response close-response-icon"></div>'
            );
            
            $wrapper.append(
                '<div class="wp-block-button"><a class="close-response wp-block-button__link">Sulje ikkuna</a></div>' +
                '<div class="wp-block-button is-style-outline"><a class="wp-block-button__link" href="https://sunloc.fi/verkkokauppa/">Tutustu tuotteisiin</a></div>'
            );
        }, 50);
    }
});


$(document).on('click', '.wpcf7 .close-response', function() {
    $(this).closest('.wpcf7-response-output').hide();
})

$(document).on('click', '.wpcf7 form.sent .wpcf7-response-output', function (event) {
    if (event.target === this) {
        $(this).hide();
    }
});

//woocommerce success message popup
$(document).on('click', '.woocommerce .message-popup .close-message', function() {
    $(this).closest('.message-popup').hide();
})

$(document).on('click', '.woocommerce .message-popup a', function() {
    $(this).closest('.message-popup').hide();
})

$(document).on('click', '.woocommerce .message-popup', function (event) {
    if (event.target === this) {
        $(this).hide();
    }
});

$(document).ready(function() {
    $(window).on('scroll', function() {
      var nonSticky = $('.total-price:not(.sticky)');
      var sticky = $('.total-price.sticky');
  
      if (nonSticky.length && sticky.length) {
        if (nonSticky.offset().top < sticky.offset().top - 29) {
            sticky.addClass('hidden-visibility');
        } else {
            sticky.removeClass('hidden-visibility');
        }
      }
    });
});

$(document).ready(function() {
    if( $('.single-product').length > 0 ) {
        Tawk_API.customStyle = {
            visibility : {
                desktop : {
                    xOffset : 20,
                    yOffset : 20,
                    position : 'bl',
                },
                mobile : {
                    xOffset : 20,
                    yOffset : 60,
                    position : 'bl',
                }
            }
        }
    }
})
